import { render, staticRenderFns } from "./voteDialog.vue?vue&type=template&id=0cb51812&scoped=true"
import script from "./voteDialog.vue?vue&type=script&lang=js"
export * from "./voteDialog.vue?vue&type=script&lang=js"
import style0 from "./voteDialog.vue?vue&type=style&index=0&id=0cb51812&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb51812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb51812')) {
      api.createRecord('0cb51812', component.options)
    } else {
      api.reload('0cb51812', component.options)
    }
    module.hot.accept("./voteDialog.vue?vue&type=template&id=0cb51812&scoped=true", function () {
      api.rerender('0cb51812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/governance/pool/voteDialog.vue"
export default component.exports